// extracted by mini-css-extract-plugin
export var black_text_group = "comparison-module--black_text_group--dba41";
export var comparison_chart_content = "comparison-module--comparison_chart_content--ecd76";
export var comparison_chart_footer = "comparison-module--comparison_chart_footer--42cff";
export var comparison_chart_mobile_carousel = "comparison-module--comparison_chart_mobile_carousel--5f2d6";
export var comparison_chart_wrapper = "comparison-module--comparison_chart_wrapper--dc8f8";
export var container = "comparison-module--container--6e38d";
export var grouped_row_item = "comparison-module--grouped_row_item--fc2dc";
export var red_text_group = "comparison-module--red_text_group--4f3e9";
export var row_container = "comparison-module--row_container--2a6ef";
export var row_content = "comparison-module--row_content--9dec7";
export var rtecenter = "comparison-module--rtecenter--f1df2";